import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comfirmation',
  templateUrl: './comfirmation.component.html',
  styleUrls: ['./comfirmation.component.scss']
})
export class ComfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
